(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-discount')) {
    customElements.define(
      'cart-discount',
      class CartDiscount extends HTMLElement {
        constructor() {
          super();
          this.form = this.querySelector('form');
          this.form?.addEventListener('submit', this.onSubmit.bind(this));
        }

        async onSubmit(event) {
          event.preventDefault();
          const input = this.querySelector('[name="discount"]');
          const button = this.querySelector('button[type="submit"]');
          const error = this.querySelector('[role="status"]');
          const code = input.value.trim();
          if (!code) {
            input.focus();
            return;
          }

          button.disabled = true;
          error.textContent = '';
          try {
            const response = await fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              body: JSON.stringify({ discount: code }),
            });
            const cart = await response.json();
            if (!response.ok || cart.errors) throw new Error(cart.description || cart.errors);

            const titles = [
              ...(cart.cart_level_discount_applications || []).map((discount) => discount.title),
              ...(cart.items || []).flatMap((item) => [
                ...(item.discounts || []).map((discount) => discount.title),
                ...(item.line_level_discount_allocations || []).map(
                  (allocation) => allocation.discount_application?.title
                ),
              ]),
            ].filter(Boolean);
            if (!titles.some((title) => title.toLowerCase() === code.toLowerCase())) throw new Error('invalid');

            await this.closest('cart-drawer').querySelector('cart-drawer-items')?.onCartUpdate();
          } catch {
            error.textContent = this.dataset.errorMessage;
          } finally {
            button.disabled = false;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
